module.exports = __webpack_public_path__ + "media/images/logo-0d6d55eb2e18a9c5f9afbf3cc0c6ecf2.svg";